<template>
    <div>
        <div class="page-container">
            <v-page-header
                :title="$t('批量导入新员工')"
                :back="{
                    title: $t('组织架构'),
                    goBack,
                }"
            />
            <div>
                <div class="page_importing"></div>
                <div class="page_text">{{ $t('批量导入新员工中…') }}</div>
                <div class="page_botton">
                    <v-button status="default" @click="goBack">{{ $t('返回组织框架') }}</v-button>
                </div>
                <div class="page_remind">
                    <div class="page_text_remind">
                        {{ $t('返回后，导入新员工仍在后台进行，导入完成后你可在【组织架构】页面查看导入结果') }}
                    </div>
                    <div class="page_text_remind">{{ $t('但直到导入完成前，你都不能对组织架构进行修改') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable prefer-destructuring */

import { Icon } from 'vhtml-ui';
import { envDomain } from '@/utils/domainConfig';

const req = require.context('@/assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    components: {},
    data() {
        return {
            taskType: 0,
            exportCheckStatusUrl: envDomain.gateway + '/v1/mng/org/importExportCheckStatus?taskType=0'
        };
    },
    computed: {},
    mounted() {
        this.getUploadStatus();
    },
    methods: {
        goBack() {
            window.location.href = '/mng/org';
        },
        getUploadStatus() {
            this.getExportStatus()
                .then(data => {
                    if (data.code === 0) {
                        if (data.data.taskStatus === 0) {
                            setTimeout(() => {
                                this.getUploadStatus();
                            }, 3000);
                        }
                        if (data.data.taskStatus === 2) {
                            window.location.href = '/mng/org/importMembersResult';
                        }
                    }
                })
                .catch(err => {
                    this.$message.error(err.message);
                });
        },
        getExportStatus() {
            return new Promise((resolve, reject) => {
                this.$ajax
                    .crossGet(this.exportCheckStatusUrl)
                    .then(data => {
                        if (data && data.code === 0) {
                            resolve(data);
                        } else {
                            reject(new Error(data.msg));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        }
    }
};
</script>

<style lang="less">
@import '../styles/app';
</style>
